<gw-modal [dismissable]="false">
  <cc-workspace-loader></cc-workspace-loader>
</gw-modal>
